var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSplitPaymentIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.9999 5.99844V10.1984M17.9999 5.99844V10.1984M17.3999 14.3984H19.7999C20.794 14.3984 21.5999 13.5926 21.5999 12.5984V4.19844C21.5999 3.20433 20.794 2.39844 19.7999 2.39844H4.1999C3.20579 2.39844 2.3999 3.20432 2.3999 4.19844V12.5984C2.3999 13.5926 3.20579 14.3984 4.1999 14.3984H6.5999M8.60484 18.2041L11.9989 21.5982M11.9989 21.5982L15.1644 18.4328M11.9989 21.5982L11.9991 14.6559M14.3999 8.39844C14.3999 9.72392 13.3254 10.7984 11.9999 10.7984C10.6744 10.7984 9.5999 9.72392 9.5999 8.39844C9.5999 7.07295 10.6744 5.99844 11.9999 5.99844C13.3254 5.99844 14.3999 7.07295 14.3999 8.39844Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSplitPaymentIcon);
export default ForwardRef;